import { localizedRoutes } from '@/lib/i18n-routes';
import i18nConfig, { Locales } from 'i18nConfig';

export type RouteKey = keyof typeof localizedRoutes;

export function getLocalizedPath(routeKey: RouteKey, locale: Locales): string {
    const isDefaultLocale = locale === i18nConfig.defaultLocale;
    const localizedPath = localizedRoutes[routeKey][locale];
    return isDefaultLocale
        ? `/${localizedPath}`
        : `/${locale}/${localizedPath}`;
}
